/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormSchemaFieldDto = {
    /**
     * Field key used in responses object
     */
    key: string;
    /**
     * Display label for the field
     */
    label: string;
    /**
     * Field type for rendering
     */
    type: FormSchemaFieldDto.type;
    /**
     * Whether the field is required
     */
    required?: boolean;
    /**
     * Options for radio, checkbox, multiselect, dropdown. Use "Other" for free-text follow-up.
     */
    options?: Array<string>;
    /**
     * Placeholder text
     */
    placeholder?: string;
    /**
     * Unit options for number fields (e.g. cm, m, in for height; kg, lb for weight)
     */
    unitOptions?: Array<string>;
    /**
     * Hint/helper text displayed below the field
     */
    hint?: string;
};
export namespace FormSchemaFieldDto {
    /**
     * Field type for rendering
     */
    export enum type {
        TEXT = 'text',
        NUMBER = 'number',
        RADIO = 'radio',
        CHECKBOX = 'checkbox',
        MULTISELECT = 'multiselect',
        DROPDOWN = 'dropdown',
        FILE = 'file',
        TEXTAREA = 'textarea',
    }
}

